import { IdValue } from '../../../shared/models/id-value.model';

export const eDisclosureTypes: IdValue[] = [new IdValue(0, 'Mail', 'Mail'), new IdValue(1, 'EDelivery', 'EDelivery')];
